function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "diamond",
  d: "M10,17.994a.486.486,0,0,1-.237-.062.234.234,0,0,1-.046-.032l-.02-.016a.3.3,0,0,0-.029-.019.163.163,0,0,1-.046-.037l-9.5-11a.5.5,0,0,1-.038-.6l4-6L4.09.218A.474.474,0,0,1,4.252.07.182.182,0,0,1,4.286.056l.026-.01L4.344.033A.248.248,0,0,1,4.418.007h.048a.048.048,0,0,0,.016,0A.051.051,0,0,1,4.5,0h11a.051.051,0,0,1,.017,0,.045.045,0,0,0,.014,0h.05a.263.263,0,0,1,.073.025l.033.014.025.01a.206.206,0,0,1,.034.014.475.475,0,0,1,.164.148l0,.005,4,6a.5.5,0,0,1-.036.6l-9.5,11a.188.188,0,0,1-.046.035.287.287,0,0,0-.03.02l-.014.012a.252.252,0,0,1-.052.038A.486.486,0,0,1,10,17.994ZM6.245,7,10,16.18,13.755,7Zm8.59,0h0l-3.215,7.858L18.406,7h-3.57ZM1.592,7l6.787,7.858L5.163,7ZM15.785,1.83h0L15.089,6h3.475L15.785,1.83ZM10,1.333,6.5,6h7Zm-5.786.5L1.434,6H4.91ZM11,1h0l3.2,4.265L14.909,1H11ZM5.089,1,5.8,5.265,9,1Z",
  transform: "translate(0)",
  fill: "#121924"
});

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 17.994,
    viewBox: "0 0 19.999 17.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.16d0e243.svg";
export { ForwardRef as ReactComponent };